<template>
  <el-dialog title="客户清单填写"
             :visible.sync="dialogVisible"
             top="10px"
             width="50%"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <el-form label-width="80px">
      <el-form-item label="无需清洗" prop="not_clear_files">
          <el-switch v-model="form.not_clear_files">
          </el-switch>
        <span class="form-item-tip">开启后将跳过地址清洗流程，直接进入下一阶段</span>
      </el-form-item>
      <template v-if="!form.not_clear_files">
        <el-form-item label="清洗规则" prop="clear_file_by">
          <el-select v-model="form.clear_file_by"
                     class="width-max">
            <el-option v-for="item in clearFileByOption"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返回时间" prop="except_upload_cleaned_file_at">
          <el-date-picker v-model="form.except_upload_cleaned_file_at"
                          class="width-max"
                          type="datetime"
                          :picker-options="dateTimeGteTodayOptions"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm"
                          placeholder="请选择期望的数据返回时间"
                          :default-time="defaultTime"
                          clearable>
          </el-date-picker>
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <el-input v-model="form.file_remarks"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入备注内容,此内容同步发送至企微通知"
                  maxlength="100"
                  show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="文件上传">
        <el-upload ref="uploadRef"
                   class="no-transition-upload"
                   action=""
                   :auto-upload="false"
                   :on-change="handleFileChange"
                   drag
                   list-type="text">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"
               style="font-size: 12px;line-height: 1.2;">
            将文件拖到此处，或<em>点击上传</em><br>
            文件多于20个时建议上传zip压缩文件
          </div>
          <template slot="file"
                    slot-scope="{ file }">
            <div class="upload-file-item">
              <a class="upload-file-link"
                 href="javascript:void(0)"
                 @click.prevent.stop="downloadProgressAttachFile(file)">
                {{ file.name }}</a>
              <i class="el-icon-download"
                 style="margin-right: 6px;cursor: pointer;"
                 @click="downloadProgressAttachFile(file)"></i>
              <i class="el-icon-delete"
                 style="cursor: pointer;"
                 @click="removeFile(file)"></i>
            </div>
          </template>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit">提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'

export default {
  mixins: [userWorkInfoMixin, projectMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      form: {
        not_clear_files: false, // 无需清洗,默认false,即需要清洗
        clear_file_by: '',
        except_upload_cleaned_file_at: null,
        file_remarks: '',
        customer_files: [], // 客户清单列表
      },
      oldNotClearFiles: null,
      clearFileByOption: [
        {value: '根据店名', label: '根据店名'},
        {value: '根据地址', label: '根据地址'},
        {value: '根据经纬度', label: '根据经纬度'},
        {value: '根据城市群组清单', label: '根据城市群组清单'},
      ],
      defaultTime: '00:00:00',
      exceptUploadCleanedFileAt: null,
    }
  },
  created () {},
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user,
    }),
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
  },
  methods: {
    initAttr (projectNode) {
      this.form.not_clear_files = _.get(projectNode, 'node_result.not_clear_files', false)
      this.form.clear_file_by = _.get(projectNode, 'node_result.clear_file_by', null)

      this.form.except_upload_cleaned_file_at = null

      this.form.customer_files = _.get(projectNode, 'node_result.customer_files', []).map(item => ({...item}))
      this.form.file_remarks = _.get(projectNode, 'node_result.file_remarks', '')
      this.oldNotClearFiles = _.get(projectNode, 'node_result.not_clear_files', null)
      this.$nextTick(() => {
        this.$refs.uploadRef.uploadFiles = this.form.customer_files.map(f => ({
          name: f.name,
          url: f.url,
          status: 'success',
          uid: f.uid || Date.now() + Math.random()
        }))
      })

      const now = new Date()
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      this.defaultTime = `${hh}:${mm}:00`
    },
    async handleFileChange (file, fileList) {
      try {
        await this.withLoading(async () => {
          const url = await this.doAdminDirectUploadFile(file.raw)
          if (url) {
            file.url = url
            this.form.customer_files.push(this.formatStandardFile(file, this.loginUser))
          } else {
            this.$refs.uploadRef.handleRemove(file)
          }
        }, '文件上传中...')
      } catch (e) {
        this.$message.error('添加至文件列表失败，原因: ' + e)
        this.$refs.uploadRef.handleRemove(file)
      }
    },
    async removeFile (file) {
      try {
        await this.$confirm(`确定要移除文件【${file.name}】吗？`, '移除文件警告')
        // 从 upload 列表移除
        this.$refs.uploadRef.handleRemove(file)
        // 从 form.customer_files 移除
        const index = this.form.customer_files.findIndex(f => f.name === file.name && f.url === file.url)
        if (index > -1) {
          this.form.customer_files.splice(index, 1)
        }
      } catch (e) {
        // 用户取消，不做任何操作
      }
    },
    async onSubmit () {
      if (this.form.not_clear_files) {
        let msg = null
        if (this.oldNotClearFiles === false) {
          msg = '上次配置为需要清洗,目前配置为<strong style="color: red;">无需清洗文件</strong>，请确认是否要更改成<strong style="color: red;">不需要</strong>清洗客户清单数据？'
        }
        if (this.oldNotClearFiles === null) {
          msg = '您本次配置为<strong style="color: red;">无需清洗文件</strong>，请确认是否<strong style="color: red;">不需要</strong>清洗客户清单数据？'
        }
        if (msg) {
          try {
            await this.$confirm(msg, '警告', {
              type: 'warning',
              dangerouslyUseHTMLString: true
            })
          } catch (e) {
            return
          }
        }
        this.form.clear_file_by = null
        this.form.except_upload_cleaned_file_at = null
      } else {
        if (!this.form.clear_file_by) {
          this.$message.error('清洗规则 不能为空')
          return
        }
        if (!this.form.except_upload_cleaned_file_at) {
          this.$message.error('返回时间 不能为空')
          return
        }
        if (new Date(this.form.except_upload_cleaned_file_at).getTime() < Date.now()) {
          this.$message.error('返回时间 不能小于当前时间')
          return
        }
      }

      const params = {
        id: this.projectId,
        ...this.form,
        except_upload_cleaned_file_at: this.form.except_upload_cleaned_file_at ? this.form.except_upload_cleaned_file_at + ':00' : null,
      }
      await this.withLoading(async () => {
        try {
          const res = await request.common('uploadCustomerListApi', params)
          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('客户清单数据保存成功')
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        }
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.upload-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file-link {
  color: #409eff;
  text-decoration: none;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
</style>

<style lang="scss">
.no-transition-upload .el-upload-list__item,
.no-transition-upload .el-list-enter-active,
.no-transition-upload .el-list-leave-active {
  transition: none !important;
}

.no-transition-upload .el-list-enter,
.no-transition-upload .el-list-leave-to {
  opacity: 1 !important;
  transform: none !important;
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/UploadCustomerListDialog.vue